(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Function to format number with comma separators
    function formatNumberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Function to update the subtotal
    function updateSubtotal() {
      // Get the section card element
      let sectionCard = this.closest('.js-budget-group');

      // Get the budget items within the section card
      let budgetItems = sectionCard.querySelectorAll(
        '.budget-item:not([hidden])'
      );

      // Initialize the subtotal
      let subtotal = 0;

      // Calculate the subtotal by summing the values of budget inputs
      budgetItems.forEach(function (item) {
        let budgetInput = item.querySelector('input[name*="_amount"]');
        subtotal += parseFloat(budgetInput?.value) || 0;
      });

      // Update the subtotal element within the section card
      let subtotalElement = sectionCard.querySelector(
        '.js-' + sectionCard.dataset.section
      );
      subtotalElement.textContent =
        '$' + formatNumberWithCommas(subtotal.toFixed(2));

      // Update the corresponding elements outside the section card
      let correspondingElements = document.querySelectorAll(
        '.js-' + sectionCard.dataset.section
      );
      correspondingElements.forEach(function (element) {
        element.textContent = '$' + formatNumberWithCommas(subtotal.toFixed(2));
      });

      // Update the total budget element
      updateTotalBudget();
    }

    // Function to update the total budget
    function updateTotalBudget() {
      // Get all the subtotal elements
      let subtotalElements = document.querySelectorAll('.js-subtotal');
      let rollover = document.querySelector(
        "input[name='cap_rollover_amount']"
      );

      // Initialize the total budget
      let totalBudget = 0;

      // Calculate the total budget by summing the subtotals
      subtotalElements.forEach(function (element) {
        totalBudget +=
          parseFloat(element.textContent.replace(/[$,]/g, '')) || 0;
      });

      totalBudget += parseFloat(rollover.value) || 0;
      // Update the total budget elements
      let totalBudgetElements = document.querySelectorAll('.js-total-budget');
      totalBudgetElements.forEach(function (element) {
        element.textContent =
          '$' + formatNumberWithCommas(totalBudget.toFixed(2));
      });
    }

    // Function to handle the deletion of a budget item
    function handleBudgetItemDeletion(event) {
      let deletedItem = event.target.closest('.budget-item');
      let budgetGroup = deletedItem.closest('.js-budget-group');
      let deleteInput = deletedItem.querySelector('input[name*="DELETE"]');
      let budgetInput = deletedItem.querySelector(
        'input[name*="budget_amount"]'
      );
      let budgetAmount = parseFloat(budgetInput.value) || 0;

      if (budgetAmount !== 0) {
        let sectionCard = deletedItem.closest('.js-budget-group');
        let subtotalElement = sectionCard.querySelector(
          '.js-' + sectionCard.dataset.section
        );
        let subtotal =
          parseFloat(subtotalElement.textContent.replace(/[$,]/g, '')) || 0;
        subtotal -= parseFloat(budgetAmount.toString().replace(/[$,]/g, ''));
        subtotalElement.textContent =
          '$' + formatNumberWithCommas(subtotal.toFixed(2));

        let correspondingElements = document.querySelectorAll(
          '.js-' + sectionCard.dataset.section
        );
        correspondingElements.forEach(function (element) {
          element.textContent =
            '$' + formatNumberWithCommas(subtotal.toFixed(2));
        });
      }

      if (deleteInput) {
        deleteInput.value = 'on';
        deletedItem.hidden = true;
      } else {
        let total = budgetGroup.querySelector(
          'input[type="hidden"][name*="TOTAL_FORMS"]'
        );
        const totalNameAttribute = total.getAttribute('name');
        let totalNameSubstring = totalNameAttribute.substring(
          0,
          totalNameAttribute.indexOf('formset-TOTAL_FORMS')
        );
        // Get the index of the item to be deleted
        const deletedItemSiblings = Array.from(
          deletedItem.parentElement.querySelectorAll('.js-budget-item')
        );
        const deletedIndex = deletedItemSiblings.indexOf(deletedItem);
        // Get all the remaining item containers after deletion
        const remainingItemsContainers =
          deletedItem.parentElement.querySelectorAll('.js-budget-item');

        // Loop through the remaining items and update their attributes
        remainingItemsContainers.forEach((remainingItem, remainingIndex) => {
          if (remainingIndex >= deletedIndex) {
            const itemNumber = remainingIndex - 1;
            remainingItem
              .querySelectorAll('input:not([type=hidden]), textarea, select')
              .forEach(function (input) {
                const parent = input.closest('.fieldWrapper');
                const label = parent.querySelector('label');
                let originalFieldId = input.getAttribute('id');
                let originalFieldName = input.getAttribute('name');
                if (originalFieldId && originalFieldName) {
                  const newId = originalFieldId.replace(/\d+/, itemNumber);
                  const newName = originalFieldName.replace(/\d+/, itemNumber);
                  let updatedNewId = newId.replace(
                    /.*(?=formset)/,
                    totalNameSubstring
                  );
                  let updatedNewName = newName.replace(
                    /.*(?=formset)/,
                    totalNameSubstring
                  );
                  input.setAttribute('id', updatedNewId);
                  input.setAttribute('name', updatedNewName);
                  label.setAttribute('for', updatedNewId);
                }
              });

            // Update hidden field attribute
            remainingItem
              .querySelectorAll('input[type=hidden]')
              .forEach(function (input) {
                let originalFieldId = input.getAttribute('id');
                let originalFieldName = input.getAttribute('name');
                if (originalFieldId && originalFieldName) {
                  const newId = originalFieldId.replace(/\d+/, itemNumber);
                  const newName = originalFieldName.replace(/\d+/, itemNumber);
                  let updatedNewId = newId.replace(
                    /.*(?=formset)/,
                    totalNameSubstring
                  );
                  let updatedNewName = newName.replace(
                    /.*(?=formset)/,
                    totalNameSubstring
                  );

                  input.setAttribute('id', updatedNewId);
                  input.setAttribute('name', updatedNewName);
                }
              });
          }
        });

        deletedItem.remove();
      }

      if (budgetGroup) {
        let totalFormsInput = budgetGroup.querySelector(
          'input[type="hidden"][name*="TOTAL_FORMS"]'
        );
        if (totalFormsInput) {
          totalFormsInput.value = parseInt(totalFormsInput.value) - 1;
        }
      }

      // Update the total budget element
      updateTotalBudget();
    }

    // Add event listener to dynamically added budget inputs
    document.addEventListener('input', function (event) {
      let target = event.target;
      if (target.matches('input[name*="budget_amount"]')) {
        updateSubtotal.call(target);
      }
    });

    // Add event listener to roll over input
    document.addEventListener('input', function (event) {
      let target = event.target;
      if (target.matches('input[name="cap_rollover_amount"]')) {
        let correspondingElements = document.querySelectorAll('.js-rollover');
        correspondingElements.forEach(function (element) {
          element.textContent =
            '$' +
            formatNumberWithCommas((parseFloat(target.value) || 0).toFixed(2));
        });

        updateNewFunding();

        updateTotalBudget();
      }
    });

    function updateNewFunding() {
      let fundingSubtotalEl = document.querySelector(
        '.js-budget-group[data-section="funding"] .js-funding'
      );
      let rollover = document.querySelector(
        "input[name='cap_rollover_amount']"
      );
      let subtotal = 0;
      if (fundingSubtotalEl) {
        let funding = fundingSubtotalEl.textContent.replace(/[$,]/g, '');
        subtotal = parseFloat(funding) || 0;
      }
      subtotal = subtotal - (parseFloat(rollover.value) || 0);

      let newFundingElements = document.querySelectorAll('.js-new-funding');
      newFundingElements.forEach(function (element) {
        element.textContent =
          '$' + formatNumberWithCommas((parseFloat(subtotal) || 0).toFixed(2));
      });
    }

    // Add event listener to the document for click events on dynamically added delete buttons
    document.addEventListener('click', function (event) {
      if (event.target.classList.contains('js-delete-budget')) {
        handleBudgetItemDeletion(event);
      }
    });

    function updateSubtotalOnLoad() {
      let rollover = document.querySelectorAll('.js-rollover');
      rollover.forEach(function (element) {
        element.textContent =
          '$' +
          formatNumberWithCommas(
            (
              parseFloat(
                document.querySelector('input[name="cap_rollover_amount"]')
                  .value
              ) || 0
            ).toFixed(2)
          );
      });
      const budgetGroups = document.querySelectorAll('.js-budget-group');
      budgetGroups.forEach(budgetGroup => {
        const budgetInputs = budgetGroup.querySelectorAll(
          'input[name*="budget_amount"]'
        );
        let subtotal = 0;
        budgetInputs.forEach(input => {
          subtotal += parseFloat(input.value) || 0;
        });
        const section = budgetGroup.dataset.section;
        const relatedElements = document.querySelectorAll(`.js-${section}`);
        relatedElements.forEach(element => {
          element.textContent =
            '$' + formatNumberWithCommas(subtotal.toFixed(2));
        });
      });

      if (budgetGroups.length > 0) {
        updateTotalBudget();
      }
    }
    // Call updateSubtotal on page load
    updateSubtotalOnLoad();
  });

  function checkRequiredFields(form) {
    // Get all the js-budget-item divs
    const budgetItems = form.querySelectorAll('.js-budget-item:not([hidden])');

    // Store the first js-budget-item div with an error
    let firstErrorCard = null;

    // Iterate over the js-budget-item divs
    for (let i = 0; i < budgetItems.length; i++) {
      const budgetItem = budgetItems[i];
      let requiredFields = [];

      requiredFields = budgetItem.querySelectorAll('[required="true"]');

      // Check if any required field inside the js-budget-item is empty
      let hasError = false;
      for (let j = 0; j < requiredFields.length; j++) {
        const field = requiredFields[j];

        // Check if the field is hidden or empty
        let isHidden = false;
        if (field.hasAttribute('hidden')) {
          isHidden = true;
        }

        if (!isHidden && !field.value.trim()) {
          hasError = true;
          break;
        }
      }
    }

    // Scroll to the first js-budget-item div with an error, if any
    if (firstErrorCard) {
      firstErrorCard.scrollIntoView({ behavior: 'smooth' });
    }

    // Return true if there are no errors
    return !firstErrorCard;
  }

  let nextButton = document.querySelector('.js-validate-budget');
  if (nextButton) {
    nextButton.addEventListener('click', function (event) {
      const form = document.getElementById('create-cap-form');
      if (form && !checkRequiredFields(form)) {
        event.preventDefault(); // Prevent form submission if required fields are not filled
      }
    });
  }
})();
